import { render, staticRenderFns } from "./bi-dashboard-edit.vue?vue&type=template&id=31013330&scoped=true"
import script from "./bi-dashboard-edit.vue?vue&type=script&lang=js"
export * from "./bi-dashboard-edit.vue?vue&type=script&lang=js"
import style0 from "./bi-dashboard-edit.vue?vue&type=style&index=0&id=31013330&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31013330",
  null
  
)

export default component.exports